import http from '../../../utils/http';
import AuthorizationError from '../../../error/AuthorizationError';
import security from '../../../utils/security'

const state = {
	loading: false,
	error: null,
	saasCompanies: null
};

const getters = {
	getSaaSCompanies: function(state){
		return state.saasCompanies;
	},
	loading: function() {
		return state.loading;
	},
  error: function() {
    return state.error;
  }
};

const actions = {
	loadSaaSCompanies({commit}, values) {
		commit('LOGIN_LOADING', true);
		
	   return http.fetch('/saas_companies', {method: 'GET'})
			   .then(function(response){ return response.json() })
			   .then(function(data) {
				   commit('LOGIN_LOADING', false);
				   commit('LOGIN_SET_SAAS_COMPANIES', data['hydra:member']);
				})
	},
	sendAuthRequest({commit}, values) {

    commit('LOGIN_LOADING', true);
		commit('LOGIN_ERROR', null);
		return http.fetch('/login', {method: 'POST', body: JSON.stringify(values)})
			   .then(function(response){ return response.json() })
			   .then(function(data) {
				   commit('LOGIN_LOADING', false);
           security.successLogin(data);
				})
				.catch(e => {
					commit('LOGIN_LOADING', false);
					if (e instanceof AuthorizationError) {
            commit('LOGIN_ERROR', e.errors);
					  return;
					}
				});
	},
};

const mutations = {
	LOGIN_LOADING(state, payload){
		state.loading = payload;
	},
	LOGIN_SET_SAAS_COMPANIES(state, payload){
		state.saasCompanies = payload;
	},
  LOGIN_ERROR(state, payload){
    state.error = payload;
  }
};

export default {
	namespaced: true,
	getters,
	state,
	actions,
	mutations
};
  


// WEBPACK FOOTER //
// ./src/store/modules/security/login.js